/* eslint-disable max-len */
/* eslint-disable no-eval */
/* eslint-disable nordic/i18n-jsx-no-literals */
const React = require('react');
const { useLiveDemoContext } = require('../base-live-demo-component/Provider/liveDemoContext');
const { brickCreationScript, paymentInterceptor, getPaymentNameById, PAYMENTS_ID } = require('./constants');

const View = ({
  theme,
  paymentId,
  showExternalReference = true,
  showStatusDetails = true,
  showTransactionDate = true,
  language,
  customVariables,
  customTexts,
}) => {
  const { setBehaviorData, formData } = useLiveDemoContext();

  React.useEffect(() => {
    const getUserCustomInputs = () => {
      let customVariablesInput = {};
      let textsInput = {};

      try {
        customVariablesInput = JSON.parse(customVariables);
        textsInput = JSON.parse(customTexts);
      // eslint-disable-next-line no-empty
      } catch (e) {}

      return {
        customVariables: customVariablesInput,
        texts: textsInput,
      };
    };

    const userCustomInputs = getUserCustomInputs();

    const getBrand = formData.brand?.brand ? formData.brand?.brand : 'cyan-light';

    window.cardStatusScreenBricksProps = {
      publicKey: 'TEST-2e029af2-a6e2-4229-8fca-886fde65f16e',
      theme: theme || 'default',
      paymentId: paymentId || PAYMENTS_ID.approved,
      language: language || 'pt-BR',
      brand: getBrand,
      showExternalReference: showExternalReference || false,
      hideStatusDetails: !showStatusDetails || false,
      hideTransactionDate: !showTransactionDate || false,
      customVariables: userCustomInputs.customVariables,
      texts: userCustomInputs.texts,
      status: getPaymentNameById(paymentId || PAYMENTS_ID.approved),
    };
    setTimeout(() => {
      setBehaviorData(prev => ({
        ...prev,
        showLayoutSpinner: false,
      }));
      if (formData.brand?.brand) {
        window.eval(brickCreationScript);
      }
    }, 1000);
  }, [
    theme,
    paymentId,
    showExternalReference,
    showStatusDetails,
    showTransactionDate,
    language,
    customVariables,
    customTexts,
    formData.brand?.brand,
  ]);

  React.useEffect(() => {
    const mpScript = document.createElement('script');
    mpScript.src = 'https://sdk.mercadopago.com/js/v2';
    document.body.appendChild(mpScript);

    const intercptorScript = document.createElement('script');
    intercptorScript.innerHTML = paymentInterceptor;
    document.body.appendChild(intercptorScript);
    return () => {
      document.body.removeChild(mpScript);
    };
  }, []);
  return (
    <>
      <div id="statusScreenBrick_container" />
    </>
  );
};

module.exports = View;
